import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { ArrowDownIcon } from '../../common/icons/arrow_down_icon';

export interface IProps {
  description: string;
  lineCounter: number;
  onShowFullInfoClick(): void;
  showMicrodata?: boolean;
  moreText?: string;
  showArrow?: boolean;
  verticalShadow?: boolean;
}

export interface IState {
  lineCounter: number;
  maxHeight?: number;
  isFullDescriptionBtnDisplayed: boolean;
}

export class Description extends React.Component<IProps, IState> {
  private textRef: HTMLParagraphElement | null = null;

  public constructor(props: IProps) {
    super(props);

    const { lineCounter = 4 } = this.props;

    // maxHeight рассчитывается из количества строк * высота строки (22px)
    this.state = {
      isFullDescriptionBtnDisplayed: true,
      lineCounter,
      maxHeight: lineCounter * 22,
    };
  }

  public componentDidMount() {
    if (this.textRef && this.state.maxHeight) {
      if (this.textRef.offsetHeight <= this.state.maxHeight) {
        this.setState({
          isFullDescriptionBtnDisplayed: false,
        });
      }
    }
  }

  public render() {
    const {
      description,
      showMicrodata,
      moreText = 'Полное описание',
      showArrow = false,
      verticalShadow = false,
    } = this.props;
    const { maxHeight, isFullDescriptionBtnDisplayed } = this.state;

    const inlineStyles = {
      maxHeight,
    };

    return (
      <div className={styles['container']}>
        <div {...mergeStyles(styles['text_container'], inlineStyles)}>
          <p
            ref={text => {
              this.textRef = text;
            }}
            className={styles['description']}
            {...(showMicrodata && { itemProp: 'description' })}
          >
            {description}
          </p>
          {isFullDescriptionBtnDisplayed && (
            <div
              onClick={this.onFullDescriptionButtonClick}
              {...mergeStyles(styles['fade_out'], verticalShadow && styles['fade_out--vertical_shadow'])}
            />
          )}
        </div>
        {isFullDescriptionBtnDisplayed && (
          <div onClick={this.onFullDescriptionButtonClick} className={styles['show_more']}>
            <span className={styles['more_text']}>{moreText}</span>
            {showArrow && <ArrowDownIcon />}
          </div>
        )}
      </div>
    );
  }

  private onFullDescriptionButtonClick = () => {
    const descriptionElement = this.textRef;

    this.setState({
      isFullDescriptionBtnDisplayed: false,
      maxHeight: descriptionElement ? descriptionElement.offsetHeight : undefined,
    });
    this.props.onShowFullInfoClick();
  };
}
